import { Component, Input, OnInit } from '@angular/core';

import { trackById } from '../../../shared/util/track-by.util';

@Component({
  selector: 'lum-location-warehouse-app-picklist-total',
  templateUrl: './location-warehouse-app-picklist-total.component.html',
  styleUrls: ['./location-warehouse-app-picklist-total.component.scss'],
})
export class LocationWarehouseAppPicklistTotalComponent implements OnInit {
  // Assuming you have 'sku' object in the component with 'active_picklist_items' property
  @Input()
  picklistItems ?:any[]; // TODO: Still using snake case for the response cannot use IPicklistItem interface

  trackById = trackById;

  constructor() {}

  ngOnInit() :void {}

  onPicklistClick(event :Event) :void {
    event.preventDefault();
  }

  get total() :number {
    return this.picklistItems?.reduce(
      (acc, item) => acc + item.available_quantity,
      0,
    );
  }
}
